export default function LogoClube() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
    >
      <path
        d="M2.87616 7.84935C2.87616 6.85713 3.40128 5.939 4.2565 5.43593L11.2351 1.33088C12.1113 0.815435 13.1981 0.815435 14.0744 1.33088L21.053 5.43593C21.9082 5.93901 22.4333 6.85713 22.4333 7.84935V16.1507C22.4333 17.1429 21.9082 18.061 21.053 18.5641L14.0744 22.6691C13.1981 23.1846 12.1113 23.1846 11.2351 22.6691L4.2565 18.5641C3.40127 18.061 2.87616 17.1429 2.87616 16.1507V7.84935Z"
        fill="#6A6A6A"
      />
      <path
        d="M3.45071 8.12953C3.45071 7.1414 3.97155 6.22642 4.82121 5.72194L11.2246 1.91994C12.1058 1.39673 13.2024 1.39673 14.0836 1.91994L20.487 5.72194C21.3366 6.22642 21.8575 7.1414 21.8575 8.12953V15.8708C21.8575 16.8589 21.3366 17.7739 20.487 18.2784L14.0836 22.0804C13.2024 22.6036 12.1058 22.6036 11.2246 22.0804L4.82121 18.2784C3.97155 17.7739 3.45071 16.8589 3.45071 15.8708V8.12953Z"
        fill="#828282"
      />
      <path
        d="M5.7522 9.2378C5.7522 8.27239 6.24953 7.37507 7.0682 6.8634L11.1707 4.29932C12.0787 3.73185 13.2308 3.73185 14.1387 4.29932L18.2413 6.8634C19.0599 7.37507 19.5573 8.27239 19.5573 9.2378V14.7622C19.5573 15.7276 19.0599 16.6249 18.2413 17.1366L14.1387 19.7007C13.2308 20.2681 12.0787 20.2681 11.1707 19.7007L7.0682 17.1366C6.24953 16.6249 5.7522 15.7276 5.7522 14.7622V9.2378Z"
        fill="#A8A8A8"
      />
      <path
        d="M11.6837 4.88814C12.5703 4.35637 13.678 4.35623 14.5645 4.88814L18.8028 7.4311C18.9044 7.49207 19.0011 7.55915 19.0929 7.6313C19.4755 8.1176 19.6935 8.72484 19.6935 9.36274V14.6372C19.6935 15.6206 19.1773 16.5325 18.3341 17.0385L14.0958 19.5815C13.2092 20.1133 12.1015 20.1133 11.2149 19.5815L6.97665 17.0385C6.87506 16.9776 6.77838 16.9105 6.68661 16.8383C6.30385 16.352 6.08603 15.7449 6.08603 15.1069V9.83247C6.08603 8.84894 6.60203 7.93713 7.4454 7.4311L11.6837 4.88814Z"
        fill="#575555"
      />
      <path
        d="M12.8049 6.68372L14.4347 9.94324L17.6942 10.3507L15.456 12.8605L16.0645 16.4623L12.8049 14.8325L9.54541 16.4623L10.1593 12.8605L7.91565 10.3507L11.1752 9.94324L12.8049 6.68372Z"
        fill="#878787"
      />
      <path
        d="M12.3678 6.8233L13.8058 9.69936L16.6818 10.0589L14.707 12.2734L15.2438 15.4515L12.3678 14.0134L9.49171 15.4515L10.0334 12.2734L8.05368 10.0589L10.9297 9.69936L12.3678 6.8233Z"
        fill="white"
      />
      <path
        d="M12.5173 6.68372L14.0512 9.75151L17.119 10.135L15.0125 12.4972L15.5851 15.8871L12.5173 14.3532L9.44954 15.8871L10.0273 12.4972L7.91565 10.135L10.9834 9.75151L12.5173 6.68372Z"
        fill="#A2ACFF"
      />
      <path
        d="M2.87616 7.84935C2.87616 6.85713 3.40127 5.939 4.2565 5.43593L11.2351 1.33088C12.1113 0.815435 13.1981 0.815435 14.0744 1.33088L21.053 5.43593C21.9082 5.93901 22.4333 6.85713 22.4333 7.84935V16.1507C22.4333 17.1429 21.9082 18.061 21.053 18.5641L14.0744 22.6691C13.1981 23.1846 12.1113 23.1846 11.2351 22.6691L4.2565 18.5641C3.40127 18.061 2.87616 17.1429 2.87616 16.1507V7.84935Z"
        fill="#3643BA"
        style={{ mixBlendMode: 'color' }}
      />
      <path
        d="M1.8938 7.60178L2.75429 5.80848L1.8938 4.01519L3.7876 4.83002L5.6814 4.01519L4.8209 5.80848L5.6814 7.60178L3.7876 6.78695L1.8938 7.60178Z"
        fill="white"
      />
    </svg>
  )
}
